<template>
  <v-container
    class="pa-0"
    fluid
  >
    <v-row>
      <v-col
        cols="3"
      >
        <v-autocomplete
          v-model="inventoryItemId"
          :items="inventoryItems"
          item-value="id"
          :item-text="
            (item) => item.material_id + ': ' + item.name
          "
          clearable
          hide-details
        >
          >
          <template slot="label">
            Inventory Item
          </template>
          <!-- eslint-disable-next-line vue/no-template-shadow -->
          <template #item="{ item }">
            <v-chip
              class="mt-1 mb-1 mr-3"
              small
              text-color="white"
              style="cursor: pointer;"
              :color="item && item.classes ? item.classes.color : 'white'"
            >
              {{ item && item.classes ? item.classes.name : '' }}
            </v-chip><span style="font-weight: bold;">{{ item.material_id }}</span><span>{{ ': ' + item.name }}</span>
          </template>
          <!-- eslint-disable-next-line vue/no-template-shadow -->
          <template #selection="{ item }">
            <v-chip
              class="mt-1 mb-1 mr-3"
              small
              text-color="white"
              style="cursor: pointer;"
              :color="item && item.classes ? item.classes.color : 'white'"
            >
              {{ item && item.classes ? item.classes.name : '' }}
            </v-chip><span style="font-weight: bold;">{{ item.material_id }}</span><span>{{ ': ' + item.name }}</span>
          </template>
        </v-autocomplete>
      </v-col>
      <!-- <v-col cols="2">
        <v-autocomplete
          v-model="uomId"
          :items="uoms"
          item-text="name"
          item-value="id"
          hide-details
          clearable
        >
          <template slot="label">
            UOM
          </template>
        </v-autocomplete>
      </v-col> -->
      <v-col
        cols="2"
      >
        <v-autocomplete
          v-model="supplierId"
          :items="suppliers"
          item-text="name"
          item-value="id"
          hide-details
          clearable
        >
          <template slot="label">
            Supplier
          </template>
        </v-autocomplete>
      </v-col>

      <v-spacer />
      <v-col
        class="text-end mt-4 pb-0"
      >
        <v-btn
          color="primary"
          outlined
          @click="open()"
        >
          <v-icon
            small
            class="mr-1"
          >
            fas fa-plus
          </v-icon>
          New Supplier Item
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pt-0">
        <v-card
          elevation="0"
          outlined
        >
          <v-data-table
            :headers="headers"
            :items="items"
            :footer-props="footer"
            :items-per-page="20"
            :search="search"
            :loading="loading"
            dense
          >
            <template #[`item.name`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.name }}
              </text-highlight>
            </template>
            <template #[`item.material_id`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.material_id }}
              </text-highlight>
            </template>
            <template #[`item.supplier`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.supplier_name }}
              </text-highlight>
            </template>
            <template #[`item.price`]="{ item }">
              <text-highlight
                :queries="search"
              >
                CAD$ {{ item.price ? parseFloat(item.price).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00' }}
              </text-highlight>
            </template>
            <template #[`item.inventory_item`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.inventory_item_full_name }}
              </text-highlight>
            </template>
            <template #[`item.actions`]="{ item }">
              <v-btn
                class="ml-1 mt-1 mb-1"
                color="primary"
                outlined
                small
                @click="open(item.id)"
              >
                EDIT
              </v-btn>
              <v-btn
                class="ml-1 mt-1 mb-1"
                color="error"
                outlined
                small
                @click="softDelete(item.id)"
              >
                DELETE
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <inventory-supplier-item-form
      ref="inventorySupplierItemForm"
      @success="success"
    />
    <confirm-form ref="confirmForm" />
  </v-container>
</template>

<script>
import InventorySupplierItemForm from '@/components/forms/InventorySupplierItemForm.vue';
import { mapState } from 'vuex';

export default {
  components: {
    InventorySupplierItemForm,
  },
  data: () => ({
    items: [],
    suppliers: [],
    uoms: [],
    inventoryItems: [],
    uomId: null,
    supplierId: null,
    inventoryItemId: null,
    selectedLocationId: 0,
    headers: [
      { text: 'Material Id', value: 'material_id' },
      { text: 'Name', value: 'name' },
      { text: 'Supplier', value: 'supplier' },
      { text: 'Price', value: 'price' },
      { text: 'Inventory Item', value: 'inventory_item' },
      { text: 'Created At', value: 'created_at' },
      { text: 'Actions', value: 'actions', align: 'end' },
    ],
    footer: {
      'items-per-page-options': [10, 20, 50, 100, 500, 1000, -1],
    },
    loading: false,
  }),
  computed: {
    ...mapState({
      search: (state) => state.search,
    }),
  },
  watch: {
    uomId() {
      this.get();
    },
    supplierId() {
      this.get();
    },
    inventoryItemId() {
      this.get();
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.get();
      this.getSuppliers();
      this.getUoms();
      this.getInventoryItems();
    },

    async get() {
      this.loading = true;
      const submitModel = {
        filters: {
          uom_id: this.uomId,
          supplier_id: this.supplierId,
          inventory_item_id: this.inventoryItemId,
        },
        search: this.search,
      };
      const res = await this.$api.inventorySupplierItem.read(submitModel);
      if (!res || !res.data) {
        this.loading = false;
        return;
      }
      this.items = res.data;
      this.loading = false;
    },

    async getSuppliers() {
      this.suppliers = await this.$api.supplier.get();
    },

    async getUoms() {
      this.uoms = await this.$api.uom.get();
    },

    async getInventoryItems() {
      const readModel = {
        filters:
        {
        },
      };

      const res = await this.$api.inventoryItem.read(readModel);
      if (!res || !res.data) return;
      this.inventoryItems = res.data;
    },

    async softDelete(id) {
      const confirm = await this.$refs.confirmForm.open({
        title: 'Are you sure that you want to delete this record?',
      });
      if (!confirm) return;
      if (!id) return;

      const res = await this.$api.inventorySupplierItem.delete(id);

      if (!res) {
        this.$bus.$emit('showError');
        return;
      }
      this.$bus.$emit('showSuccess');
      this.get();
    },

    open(id) {
      this.$refs.inventorySupplierItemForm.open(id);
    },

    success() {
      this.$bus.$emit('showSuccess');
      this.get();
    },
  },
};
</script>
